import axios from "axios";
import { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { SetMetaTags } from "../../Components/Utility/setMetaTags";

function Cancellation() {
  const [cancelPolicy, setCancelPolicy] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchCancelPolicyData = async () => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE}/getCmsContent`,
        {
          post_url: "cancellation-policy",
        }
      );
      setCancelPolicy(res.data.data);
    } catch (err) {
      console.error("Error fetching cancellation policy:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    fetchCancelPolicyData();
  }, []);

  return (
    <section className="ser_v_araeea faqess">
      <SetMetaTags
        title={cancelPolicy?.meta_title}
        description={cancelPolicy?.meta_description}
        keywords={cancelPolicy?.meta_keyword}
      />

      <div className="container">
        <div className="faq_contentss">
          {loading ? (
            <Skeleton count={5} height={20} style={{ marginBottom: "10px" }} />
          ) : (
            <div dangerouslySetInnerHTML={{ __html: cancelPolicy?.content }} />
          )}
        </div>
      </div>
    </section>
  );
}

export default Cancellation;
